import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default register('hero-slider', {
  onLoad() {
    this.settings = this.container.dataset.sectionSettings || '{}';

    this.sliderId = '#hero-slider--' + this.id;
    const thisSlider = document.querySelector('#hero-slider--' + this.id);

    // Parse the settings string passed through from liquid
    this.userSettings = JSON.parse(this.settings);

    this.previousButton = document.querySelector('.btn--control__prev');
    this.nextButton = document.querySelector('.btn--control__next');

    var slider = new Flickity(thisSlider, {
      freeScroll: false,
      contain: true,
      prevNextButtons: false,
      autoPlay: this.userSettings.autoplay,
      pageDots: this.userSettings.include_pager_dots,
      imagesLoaded: true,
      setGallerySize: true,
      cellAlign: 'center',
      watchCSS: true,
      lazyLoad: true,
      wrapAround: this.userSettings.infinite,
      on: {
        ready: function() {
          thisSlider.classList.add('is-visible');
        },
      },
    });

    if (this.previousButton) {
      this.previousButton.addEventListener('click', function() {
        slider.previous();
      });
      this.nextButton.addEventListener('click', function() {
        slider.next();
      });
    }
  },
});
